import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  AppState,
  UsageSpaceFilterState,
  UsageSpaceRange,
} from '@immosky/types';
import { Subscription } from 'rxjs';
import {
  resetUsageSpaceFilter,
  selectUsageSpaceFilterState,
  setUsageSpaceFilter,
} from '@immosky/object-search-filter';

@Component({
  selector: 'app-usage-space-filter-dropdown',
  templateUrl: './usage-space-filter-dropdown.component.html',
  styleUrls: ['./usage-space-filter-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsageSpaceFilterDropdownComponent implements OnDestroy {
  private subscription: Subscription;

  appliedFilter!: UsageSpaceRange;
  currentFilter!: UsageSpaceRange;
  isActive = false;

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    this.subscription = this.store
      .pipe(select(selectUsageSpaceFilterState))
      .subscribe((filterState: UsageSpaceFilterState) => {
        this.appliedFilter = {
          ...filterState.filter,
        };
        this.currentFilter = {
          ...filterState.filter,
        };
        this.isActive = filterState.isActive;
        this.cdRef.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  select(filter: UsageSpaceRange) {
    this.currentFilter = filter;
  }

  applyChanges() {
    if (this.currentFilter) {
      this.store.dispatch(
        setUsageSpaceFilter({
          filter: this.currentFilter,
        })
      );
    }
  }

  reset() {
    this.store.dispatch(resetUsageSpaceFilter());
  }
}
